/* 
 	* 指令下发组件 
 	* 设置多时段震动监测功能
 	* 创建时间：2017-07-11
 	* 创建人：ShujuanSun 
*/
<template>
    <div id="BKMonitor">
		<form class="form-horizontal">
			<!--1-->
			<div class="form-group" v-if="timeCount >= 1">
				<button class="btn btn-primary col-sm-1"  type="button" @click="deleteTime">删除</button>
				<label class="control-label col-sm-2"><span class="red pr5px">*</span>监控时间</label>
				<div class=" col-sm-2">
					<input type="text" class="form-control time" placeholder="HH:mm" v-model="time1"> 
				</div>
			    <label class="control-label col-sm-1"><span class="red pr5px">*</span>时长</label>
			    <div class="col-sm-2">
			    	 <input type="text" class="form-control col-sm-1 timeD" v-model="timeD1"> 
			    </div>
			    <span class="col-sm-4 pt5px orange_t" >单位为5分钟，有效范围6~255</span>
			</div>
			<!--2-->
			<div class="form-group" v-if="timeCount >= 2">
				<button class="btn btn-primary col-sm-1"  type="button" @click="deleteTime">删除</button>
				<label class="control-label col-sm-2"><span class="red pr5px">*</span>监控时间</label>
				<div class=" col-sm-2">
					<input type="text" class="form-control time" placeholder="HH:mm" v-model="time2">
				</div>
			    <label class="control-label col-sm-1"><span class="red pr5px">*</span>时长</label>
			    <div class="col-sm-2">
			    	 <input type="text" class="form-control col-sm-1 timeD" v-model="timeD2">
	
			    </div>
			    <span class="col-sm-4 pt5px orange_t" >单位为5分钟，有效范围6~255</span>
			</div>
			<!--3-->
			<div class="form-group" v-if="timeCount >= 3">
				<button class="btn btn-primary col-sm-1" type="button" @click="deleteTime">删除</button>
				<label class="control-label col-sm-2"><span class="red pr5px">*</span>监控时间</label>
				<div class=" col-sm-2">
					<input type="text" class="form-control time" placeholder="HH:mm" v-model="time3">

				</div>
			    <label class="control-label col-sm-1"><span class="red pr5px">*</span>时长</label>
			    <div class="col-sm-2">
			    	 <input type="text" class="form-control col-sm-1 timeD" v-model="timeD3">
	
			    </div>
			    <span class="col-sm-4 pt5px orange_t" >单位为5分钟，有效范围6~255</span>
			</div>
			<!--4-->
	        <div class="form-group" v-if="timeCount >= 4">
				<button class="btn btn-primary col-sm-1"  type="button" @click="deleteTime">删除</button>
				<label class="control-label col-sm-2"><span class="red pr5px">*</span>监控时间</label>
				<div class=" col-sm-2">
					<input type="text" class="form-control time" placeholder="HH:mm" v-model="time4">

				</div>
			    <label class="control-label col-sm-1"><span class="red pr5px">*</span>时长</label>
			    <div class="col-sm-2">
			    	 <input type="text" class="form-control col-sm-1 timeD" v-model="timeD4">
	
			    </div>
			    <span class="col-sm-4 pt5px orange_t" >单位为5分钟，有效范围6~255</span>
			</div>
			<!--5-->
	<div class="form-group" v-if="timeCount >= 5">
				<button class="btn btn-primary col-sm-1"  type="button" @click="deleteTime">删除</button>
				<label class="control-label col-sm-2"><span class="red pr5px">*</span>监控时间</label>
				<div class=" col-sm-2">
					<input type="text" class="form-control time" placeholder="HH:mm" v-model="time5">

				</div>
			    <label class="control-label col-sm-1"><span class="red pr5px">*</span>时长</label>
			    <div class="col-sm-2">
			    	 <input type="text" class="form-control col-sm-1 timeD" v-model="timeD5">
	
			    </div>
			    <span class="col-sm-4 pt5px orange_t" >单位为5分钟，有效范围6~255</span>
			</div>
			<div class="form-group">
				<button class="btn btn-primary" type="button" @click="addTime">添加</button>
				<span class=" orange_t pl10px">最多可设置5个，需从小到大设置，时段之间不得小于60分钟，否则不便于停车判断</span>
			</div>
			 <div class="form-group">
				<label class="col-sm-3 control-label"></label>
				<div class="col-sm-8">
					<span class="red pt5px">{{alertMsg}}</span>
				</div>
			</div>
		   <div class="form-group text-right pr10px" >
		    	<button type="button" class="btn btn-primary modal-btn" @click="withdrawBtn">取消</button>
		    	<button type="button" class="btn btn-primary modal-btn" @click="nextClick">下一步</button>
		    </div>
		</form>
    </div>	
</template>
<script>
	export default {
		name: "InsBKMonitor",
		data() {
			return {
				timeCount:1,
				time1:'',
				timeD1:'',
				time2:'',
				timeD2:'',
				time3:'',
				timeD3:'',
				time4:'',
				timeD4:'',
				time5:'',
				timeD5:'',
				alertMsg:''
			};	
		},
		props:['from','delCmd'],
		watch:{
			delCmd(val){
				if(val){
					this.resetInput()
				}
			}
		},
		methods: {
			deleteTime(){
				if(this.timeCount > 1){
					this.timeCount --
					
				}
			},
			addTime(){ 
				if(this.timeCount < 5){
					this.timeCount ++ 
				}
			}, 
			resetInput(){
				this.timeCount = 1
				this.time1 = ''
				this.time2 = ''
				this.time3 = ''
				this.time4 = ''
				this.time5 = ''
				this.timeD1 = ''
				this.timeD2 = ''
				this.timeD3 = ''
				this.timeD4 = ''
				this.timeD5 = ''
				this.alertMsg = ''
			},
			withdrawBtn(){
				this.resetInput()
				if(this.from=='monitor'){
					this.$store.dispatch('instModalHide')
				}else{
					this.$emit('withdrawBtn')
				}
			},
			compareFunc(t1,t2){
				let h1 = t1.split(':')[0]
				let m1 = t1.split(':')[1]
				let h2 = t2.split(':')[0]
				let m2 = t2.split(":")[1]
				return Number(h2)*60 + Number(m2) - (Number(h1)*60 + Number(m1)) >= 60
			},
			nextClick(){ 
				const that = this
				let r1 = /^(?:(?:0|1)\d|2[0-3]):[0-5]\d$/.test(that.time1)
				let r2 = /^(?:(?:0|1)\d|2[0-3]):[0-5]\d$/.test(that.time2)
				let r3 = /^(?:(?:0|1)\d|2[0-3]):[0-5]\d$/.test(that.time3)
				let r4 = /^(?:(?:0|1)\d|2[0-3]):[0-5]\d$/.test(that.time4)
				let r5 = /^(?:(?:0|1)\d|2[0-3]):[0-5]\d$/.test(that.time5)
				if(this.timeCount == 1){
				 	if(!r1){
						this.alertMsg='监控时间填写不正确'
						return
					}else{
						this.alertMsg = ''
					}
					let r = /^[6-9]$|^[1-9]\d$|^1\d{2}|^2[0-5][0-5]$/.test(that.timeD1)
					if(!r){
						this.alertMsg = '时长填写不正确'
						return
					}else{
						this.alertMsg = ''
					}
				}else if(this.timeCount == 2){ 
					let compare = this.compareFunc(that.time1,that.time2)
					if(compare){
						this.alertMsg = ''
					}else{
						this.alertMsg = '请从小到大设置监控时间且间隔最小60分钟'
						return
					}
				 	if(r2){
						this.alertMsg = ''
					}else{
						this.alertMsg='监控时间填写不正确'
						return
					}
					let r = /^[6-9]$|^[1-9]\d$|^1\d{2}|^2[0-5][0-5]$/.test(that.timeD2)
					if(!r){
						this.alertMsg = '时长填写不正确'
						return
					}else{
						this.alertMsg = ''
					}
				}else if(this.timeCount == 3){
					let compare1 = this.compareFunc(that.time1,that.time2)
					let compare2 = this.compareFunc(that.time2,that.time3)
					if(compare1 && compare2){
						this.alertMsg = ''
					}else{
						this.alertMsg = '请从小到大设置监控时间且间隔最小60分钟'
						return
					}
				 	if(!r3){
						this.alertMsg='监控时间填写不正确'
						return
					}else{
						this.alertMsg = ''
					}
					let r = /^[6-9]$|^[1-9]\d$|^1\d{2}|^2[0-5][0-5]$/.test(that.timeD3)
					if(!r){
						this.alertMsg = '时长填写不正确'
						return
					}else{
						this.alertMsg = ''
					}
					
				}else if(this.timeCount == 4){
					let compare1 = this.compareFunc(that.time1,that.time2)
					let compare2 = this.compareFunc(that.time2,that.time3)
					let compare3 = this.compareFunc(that.time3,that.time4)
					if(compare1 && compare2 && compare3){
						this.alertMsg = ''
					}else{
						this.alertMsg = '请从小到大设置监控时间且间隔最小60分钟'
						return
					}
				 	if(!r4){
						this.alertMsg='监控时间填写不正确'
						return
					}else{
						this.alertMsg = ''
					}
					let r = /^[6-9]$|^[1-9]\d$|^1\d{2}|^2[0-5][0-5]$/.test(that.timeD4)
					if(!r){
						this.alertMsg = '时长填写不正确'
						return
					}else{
						this.alertMsg = ''
					}
				}else if(this.timeCount == 5){
					let compare1 = this.compareFunc(that.time1,that.time2)
					let compare2 = this.compareFunc(that.time2,that.time3)
					let compare3 = this.compareFunc(that.time3,that.time4)
					let compare4 = this.compareFunc(that.time4,that.time5)
					if(compare1 && compare2 && compare3 && compare4){
						this.alertMsg = '' 
					}else{
						this.alertMsg = '请从小到大设置监控时间且间隔最小60分钟'
						return
					}
				 	if(!r5){
						this.alertMsg='监控时间填写不正确'
						return
					}else{
						this.alertMsg = ''
					}
					let r = /^[6-9]$|^[1-9]\d$|^1\d{2}|^2[0-5][0-5]$/.test(that.timeD5)
					if(!r){
						this.alertMsg = '时长填写不正确'
						return
					}else{
						this.alertMsg = ''
					}
				}else{
					return
				}
					let arr = []
					switch(this.timeCount){
						case 1:
							arr = ['SETPRM',18,this.time1,this.timeD1]
							break;
						case 2:
							arr =  ['SETPRM',18,this.time1,this.timeD1,this.time2, this.timeD2]
							break;
						case 3:
							arr = ['SETPRM',18,this.time1,this.timeD1,this.time2, this.timeD2,this.time3, this.timeD3]
							break;
						case 4:
							arr = ['SETPRM',18,this.time1,this.timeD1,this.time2, this.timeD2,this.time3, this.timeD3,this.time4, this.timeD4]
							break;
						case 5:
							arr = ['SETPRM',18,this.time1,this.timeD1,this.time2, this.timeD2,this.time3, this.timeD3,this.time4, this.timeD4,this.time5, this.timeD5]
							break;
						default:
							arr = ['SETPRM',18]
							break;
					}
					if(this.from=='monitor'){
						this.$store.dispatch('getCmdInfo',arr)
					}else{
						this.$emit('nextClick',arr)
					}
				
		    }
	    }
	}
</script>



// WEBPACK FOOTER //
// InsBKMonitor.vue?488bf072